import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useFormStore = create(
  persist(
    (set, get) => ({
      formData: {},

      setField: (name, value) =>
        set(state => ({
          formData: { ...state.formData, [name]: value }
        })),

      resetForm: () => set({ formData: {} }),

      setFormData: (data) => set({ formData: { ...data } }),

      getField: (name) => get().formData[name],

      getFormData: () => get().formData,
    }),
    {
      name: 'form-storage',
    }
  )
);
